import React from 'react';
import { useLocation } from 'react-router-dom';
import Store from '../../store/Store';

interface FooterProps {
    children?: React.ReactNode;
}

const excludes = ['/search', '/mapEdit', '/order'];

const footerLinks = [
    { label: 'Kontakt', path: 'contact', dataPw: 'button-contact' },
    { label: 'Impressum', path: 'imprint', dataPw: 'button-imprint' },
    { label: 'Barrierefreiheitserklärung', path: 'access', dataPw: 'button-access' },
    { label: 'Datenschutz', path: 'policy', dataPw: 'button-policy' },
    { label: 'FAQs', path: 'faq', dataPw: 'button-faq' },
];

export const Footer: React.FC<FooterProps> = props => {
    const location = useLocation();

    if (excludes.includes(location.pathname)) return null;

    return (
        <div className='footer-div'>
            <div className="pb-[20px] pt-[10px] px-[20px] relative page-footer flex flex-col-reverse lg:flex-row justify-between gap-6 lg:gap-12">
                <div className='content-center'>
                    <nav className="footer-nav flex flex-col lg:flex-row gap-4" aria-label="Fußnavigation">
                        {footerLinks.map((link, index) => (
                            <React.Fragment key={link.path}>
                                <button
                                    type="button"
                                    data-pw={link.dataPw}
                                    onClick={() => Store.navigate(link.path)}
                                >
                                    {link.label}
                                </button>
                                {index < footerLinks.length - 1 && (
                                    <span className="footer-separator" aria-hidden="true">•</span>
                                )}
                            </React.Fragment>
                        ))}
                    </nav>
                    {props.children}
                </div>

                <div>
                    <img src='../assets/bmf.png' width="250" alt='Logo Bundesministerium für Finanzen' />
                </div>
            </div>
        </div>
    );
};
